module.exports = __webpack_public_path__ + "static/logos-12-5037d42db91562638c8ac070ca9e46c0.png";